import classNames from 'classnames';
import PropTypes from 'prop-types';

const BaseCardBody = ({
  id = '',
  children = [],
  className = '',
  withPadding = false,
}) => {
  const mainClass = classNames({
    'rounded bg-white': true,
    'py-3 px-4': withPadding,
  }, className);

  return (
    <div
      {...(id ? { id } : {})}
      {...(id ? { 'data-testid': id} : {})}
      className={mainClass}
    >
      {children}
    </div>
  );
};

BaseCardBody.displayName = 'BaseCardBody';

BaseCardBody.propTypes = {
  id: PropTypes.string,
  children: PropTypes.node,
  className: PropTypes.string,
  withPadding: PropTypes.bool,
};

export default BaseCardBody;